"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatSpace = void 0;
var react_1 = __importDefault(require("react"));
var constants_1 = require("../constants");
var colors_1 = require("../../colors");
var ChatSpace = function (_a) {
    var color = _a.color, height = _a.height, size = _a.size, width = _a.width;
    return (react_1.default.createElement("svg", { width: width || size || constants_1.DEFAULT_ICON_SIZE, height: height || size || constants_1.DEFAULT_ICON_SIZE, viewBox: '0 0 32 32', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M7.05 4H25.95C28.1868 4 30 5.79569 30 8.01079V21.3801C30 23.5952 28.1868 25.3909 25.95 25.3909H20.9587L17.4361 28.7193C16.8692 29.0936 16.1308 29.0936 15.5639 28.7193L12.0413 25.3909H7.05C4.81325 25.3909 3 23.5952 3 21.3801V8.01079C3 5.79569 4.81325 4 7.05 4Z', fill: color ? (0, colors_1.getColor)(color) : 'currentColor' })));
};
exports.ChatSpace = ChatSpace;
